module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/venue-img-two-07c90504fbfb61a5fc32eb7ac0416b9d.jpg";